module.exports = __webpack_public_path__ + "img/Menu.61faabd2.svg";